import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import styled from 'styled-components/macro';
import * as colors from 'components/common/colorConstants';

// use this for short messages like an ID, it shrinks to the exact width of the text
export const ToolTip = styled(Tippy)`
  padding: 5;
  font-size: 8px;
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 500;
  background: ${colors.darkGray2};
  text-align: left;
  &[data-placement^='bottom'] {
    .tippy-arrow {
      border-top-color: ${colors.darkGray2};
    }
  }

  &:hover {
    cursor: pointer;
  }
`;

// use this for paragrphs, it won't inifinitely grow horizontally
export const ToolTipFixedWidth = styled(ToolTip)`
  width: 200px;
`;

export const ToolTipIntentValidation = styled(ToolTip)`
  max-width: 300px;
  font-size: 11px;
`;
